import { Actors as A, Tenants as T } from '@mntn/auth-types'
import { ErrorSchema as E } from '@mntn/result'
import { z } from 'zod'

export const ProgramGenreResponseSchema = z.object({
  name: z.string(),
  programGenreId: z.number().int().positive(),
})

export const GetProgramGenresQuerySchema = z.object({
  'only-populated': z.preprocess(val => val === 'true', z.boolean().optional()),
})

export const GetProgramGenresResponseBodySchema = z.object({
  data: z.array(ProgramGenreResponseSchema),
})

export const GetProgramGenresSuccessResponseSchema = z
  .object({
    ok: z.literal(true),
    data: z.array(ProgramGenreResponseSchema),
  })
  .transform(({ data }) => ({ data }))
  .pipe(GetProgramGenresResponseBodySchema)

export const GetProgramGenresResponseSchema = {
  200: GetProgramGenresSuccessResponseSchema,
  500: E('PROGRAM_GENRES_QUERY_DB_ERROR'),
}

export const GetProgramGenresRequestSchema = z
  .object({
    query: z.custom<z.output<typeof GetProgramGenresQuerySchema>>(),
    principal: T.KindSchema(['advertiser', 'publisher']).and(A.UserSchema),
  })
  .transform(({ query, principal }) => ({
    in: { onlyPopulated: query['only-populated'] },
    principal,
  }))
